import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

type StyledSliderRangeProps = {
  width?: string;
};
export const StyledRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
`;

export const StyledSliderBox = styled.div`
  border: 1px solid ${theme.colors.purple_2};
  border-radius: 12px;
  padding: 0 16px;
  width: -webkit-fill-available;

  & .rounded-container-title {
    margin: 13px 0 0;
    display: block;
    min-height: 20px;
  }
`;

export const StyledSliderContainer = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 30px;
  margin-bottom: 30px;
  opacity: ${({ $disabled }) => ($disabled ? "0.6" : "")};
`;

export const Thumb = styled.input<{ $zIndex?: number; $disabled?: boolean }>`
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 100%;
  outline: none;
  z-index: ${({ $zIndex: zIndex }) => zIndex ?? 3};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    background-color: ${theme.colors.purple};
    border: 2px solid ${theme.colors.purple};
    border-radius: 50%;
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    height: 14px;
    width: 14px;
    margin-top: 0px;
    pointer-events: all;
    position: relative;
  }

  &::-moz-range-thumb {
    background-color: ${theme.colors.purple};
    border: 2px solid ${theme.colors.purple};
    border-radius: 50%;
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    height: 14px;
    width: 14px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
`;

export const StyledThumbLeft = styled(Thumb)`
  z-index: ${(props) => props.$zIndex ?? 3};
`;

export const StyledSlider = styled.div`
  position: relative;
  width: 100%;
  padding: 0 8px;
`;

export const StyledTickItem = styled.div<{
  $position: number;
  $isBoundary?: boolean;
  $disabled?: boolean;
}>`
  position: absolute;
  top: 50%;
  left: ${({ $position: position }) => `${position}%`};
  transform: ${({ $isBoundary }) =>
    $isBoundary ? "none" : "translateX(-50%)"};
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  gap: 10px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`;

export const StyledTickDot = styled.div<{ $active?: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ $active }) =>
    $active ? theme.colors.trasparent : theme.colors.grey_4};
  position: relative;
  top: -3px;
  z-index: 2;

  .label-levels {
    margin-top: 6px;
  }
`;

const Track = styled.div`
  position: absolute;
  border-radius: 3px;
  height: 6px;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
`;

export const StyledSliderTrack = styled(Track)`
  background-color: ${theme.colors.grey_7};
  width: 100%;
`;

export const StyledSliderRange = styled(Track)<StyledSliderRangeProps>`
  background-color: ${theme.colors.purple};
  width: ${({ width }) => width};
`;
